import {Localization} from '../utils/Localization.js';
import {DataManager} from './DataManager.js';

export type TextManagerKeys =
    | 'GenericMenuText'
    | 'GameplayText'
    | 'genericGameOverText'
    | 'gameOverTimedText'
    | 'gameOverSkullText'
    | 'gameOverFruitText'
    | 'gameOverBlobText'
    | 'gameOverWinText'
    | 'welcomeText'
    | 'scrollingText'
    | 'inGameChatter'
    | 'inGameChatterRisingColumn'
    | 'inGameChatterTimed'
    | 'inGameTutorialText'
    | 'optionsText'
    | 'statsText'
    | 'achievementText'
    | 'gameSetUpText'
    | 'gameOverMenuText'
    | 'gameOverMenuHighScoreText'
    | 'storeMenuText'
    | 'newsMenuText'
    | 'storeMenuMalwearText'
    | 'storeMenuInventoryText'
    | 'missionMenuText'
    | 'missionMenuCompleteText';

export type TextMap = {
    [key in TextManagerKeys]: string[];
};

export class TextManager {
    private static _instance: TextManager;

    private _isloaded: boolean = false;
    public get isLoaded(): boolean {
        return this._isloaded;
    }

    static get instance(): TextManager {
        if (!TextManager._instance) {
            TextManager._instance = new TextManager();
        }
        return TextManager._instance;
    }

    private constructor() {
        DataManager.instance.loadData<TextMap>('data/TextManager.bin').then((data) => {
            for (const key in data) {
                this._texts.set(key as TextManagerKeys, data[key]);
            }
            this._isloaded = true;
        });
    }

    private _texts: Map<TextManagerKeys, string[]> = new Map();

    public getInGameTutorialText(index: number): string {
        return Localization.instance.get(this._texts.get('inGameTutorialText')[index]);
    }
}
